/* eslint-disable */
import React, { useMemo, useState } from "react";
import { Modal, Button, Upload, Typography, message } from "antd";
import {
  UploadOutlined,
  MenuOutlined,
  FileTextOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
const { Text } = Typography;
export default function UploadTransactionsModal({
  open,
  onClose,
  onFileSelected,
  type = "transactions",
}) {
  const [fileList, setFileList] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [uploading, setUploading] = useState(false);
  const reset = () => {
    setFileList([]);
    setErrorMsg("");
  };
  const uploadConfig = useMemo(() => {
    switch (type) {
      case "bai":
        return {
          title: "Upload BAI File",
          api: api.getBaiUpload,
          simpleRight: true,
          accept: ".bai",
          reg: /\.bai$/i,
          errorMsg: "File has an invalid extension, it should be .bai",
        };
      case "balance":
        return {
          title: "Upload Bank Balance",
          api: api.getBalanceUpload,
          simpleRight: false,
          accept: ".csv",
          reg: /\.csv$/i,
          errorMsg: "File has an invalid extension, it should be .csv",
        };
      default:
        return {
          title: "Upload Bank Transactions",
          api: api.getUploadTransacions,
          simpleRight: false,
          accept: ".csv",
          reg: /\.csv$/i,
          errorMsg: "File has an invalid extension, it should be .csv",
        };
    }
  }, [type]);
  const customRequest = async ({ file, onSuccess, onError }) => {
    const isValid = uploadConfig.reg.test(file?.name || "");
    if (!isValid) {
      setErrorMsg(uploadConfig.errorMsg);
      onError?.(new Error("Invalid file type"));
      return;
    }
    if (uploading) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append("files", file);
      const res = await http.post(uploadConfig.api, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res?.code === "1") {
        message.success("Upload success!");
        setFileList([
          {
            uid: file.uid,
            name: file.name,
            status: "done",
            response: res,
            originFileObj: file,
          },
        ]);

        onFileSelected?.(res.data);
        onSuccess?.(res);
      } else {
        throw new Error(res?.msg || "Upload failed");
      }
    } catch (err) {
      setErrorMsg(err.message || "Upload failed");
      message.error("Upload failed");
      onError?.(err);
    } finally {
      setUploading(false);
    }
  };

  const beforeUpload = (file) => {
    const isValid = uploadConfig.reg.test(file?.name || "");
    if (!isValid) {
      setErrorMsg(uploadConfig.errorMsg);
      return Upload.LIST_IGNORE;
    }
    setErrorMsg("");
    return true;
  };

  const handleDownloadInstruction = () => {
    const link = document.createElement("a");
    link.href = "/files/Bank-Transaction-Upload-Instruction.docx";
    link.download = "Bank-Transaction-Upload-Instruction.docx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const uploadCommonProps = useMemo(
    () => ({
      multiple: false,
      accept: uploadConfig.accept,
      fileList,
      beforeUpload,
      customRequest,
      onRemove: () => {
        setFileList([]);
        setErrorMsg("");
      },
      showUploadList: {
        showRemoveIcon: true,
        showPreviewIcon: false,
      },
      disabled: uploading,
    }),
    [fileList, uploading, uploadConfig]
  );
  return (
    <Modal
      open={open}
      width="95%"
      centered
      destroyOnClose
        maskClosable={false} 
      onCancel={() => onClose?.()}
      afterClose={reset}
      footer={
         <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
        <Button key="close" onClick={onClose}>
          Close
        </Button>
      </div>}
      title={null}
      Style={{ padding: 0 }}
    >
      <div
        style={{
          height: "78vh",
          minHeight: 520,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div style={{ padding: "14px 16px" }}>
          <div
            style={{
              width: "52%",
              display: "flex",
              alignItems: "center",
              gap: 10,
            }}
          >
            <UploadOutlined style={{ color: "#e55353", fontSize: 18 }} />
            <Text style={{ color: "#e55353", fontWeight: 700, fontSize: 18 }}>
              Upload Bank Transactions
            </Text>
          </div>
          <div className="model_top"></div>
        </div>

        <div style={{ flex: 1, display: "flex" }}>
          <div style={{ width: "52%", borderRight: "1px solid #f0f0f0" }}>
            <div style={{ padding: 24, height: "100%" }}>
              <Upload {...uploadCommonProps} style={{ width: "100%" }}>
                <Button
                  type="primary"
                  loading={uploading}
                  disabled={uploading}
                  icon={<UploadOutlined />}
                >
                  Select File
                </Button>
              </Upload>

              {/* 错误条 */}
              {!!errorMsg && (
                <div
                  style={{
                    marginTop: 16,
                    background: "#d9534f",
                    color: "#fff",
                    padding: "12px 14px",
                    borderRadius: 4,
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                  }}
                >
                  <ExclamationCircleOutlined />
                  <span style={{ fontWeight: 600 }}>{errorMsg}</span>
                </div>
              )}
            </div>
          </div>

          {/* 右侧：说明区 */}
          <div style={{ width: "48%" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <MenuOutlined style={{ color: "#666", fontSize: 18 }} />
              <Text style={{ fontWeight: 600, fontSize: 16, color: "#666" }}>
                Information Detail
              </Text>
            </div>

            <div
              style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "0 36px",
              }}
            >
              <div style={{ textAlign: "center" }}>
                <div
                  style={{ fontSize: 26, color: "#8c8c8c", lineHeight: 1.3 }}
                >
                  To Use {uploadConfig.title},
                  <br />
                  Please Drag & Drop a CSV File
                </div>

                {/* 非 BAI 显示 */}
                {!uploadConfig.simpleRight && (
                  <>
                    <div
                      style={{
                        marginTop: 24,
                        fontSize: 18,
                        color: "#8c8c8c",
                        lineHeight: 1.6,
                      }}
                    >
                      Upload bank transactions allows users to add single and
                      multiple bank transactions
                      <br />
                      For the CSV file formatting instructions please click link
                      below
                    </div>

                    <div style={{ marginTop: 34 }}>
                      <Button
                        type="primary"
                        size="large"
                        icon={<FileTextOutlined />}
                        onClick={handleDownloadInstruction}
                        style={{
                          height: 56,
                          padding: "0 28px",
                          fontSize: 18,
                          textDecoration: "underline",
                        }}
                      >
                        Click Here for File Format Instruction
                      </Button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
